
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;

    class Cleanwater extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://resourcewatch.org/embed/map/98ad7d85-21e3-40b5-870a-4644ade24c25'
        };
    }

    render() {
        return (
            <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default Cleanwater;